import Vuex from "vuex";
import Vue from "vue";
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

const state = {
  auth: false,
  token: "",
  refresh: "",
  expires: new Date(),
  logsPinned: false,
  settings: {}
};

const getters = {
  getIsAuth: (state) => state.auth,
  getToken: (state) => state.token,
  getRefresh: (state) => state.refresh,
  getExpires: (state) => state.expires,
  getIsExpired: (state) =>
    new Date(state.expires).getTime() < new Date().getTime(),
  getIsLogsPinned: (state) => state.logsPinned,
  getSettings: (state) => state.settings,

};

const actions = {};

const mutations = {
  SET_AUTH(state, auth) {
    state.auth = auth;
  },
  SET_TOKEN(state, token) {
    state.token = token;
  },
  SET_REFRESH(state, refresh) {
    state.refresh = refresh;
  },
  SET_EXPIRES(state, expires) {
    state.expires = expires;
  },
  SET_LOGSPINNED(state, logsPinned) {
    state.logsPinned = logsPinned;
  },
  SET_SETTINGS(state, settings) {
    state.settings = settings;
  },
};

export default new Vuex.Store({
  state,
  getters,
  actions,
  mutations,
  plugins: [createPersistedState()],
});
